import {
  TransformRTMPPushChannelAPIToClient,
  TransformRTMPPushChannelClientToAPI,
} from '../utils/rtmp';

let module = angular.module('app.resources');

module.factory('RTMPPushChannel', ($resource) => {
  'ngInject';

  return $resource(
    `${API_ROOT}/account/rtmp_push_channels/:id`,
    { id: '@id' },
    {
      query: {
        method: 'GET',
        isArray: true,
        transformResponse: (data, headersGetter, status) =>
          _.map(angular.fromJson(data), TransformRTMPPushChannelAPIToClient),
      },
      get: {
        method: 'GET',
        transformResponse: (data, headersGetter, status) =>
          TransformRTMPPushChannelAPIToClient(angular.fromJson(data)),
      },
      create: {
        method: 'POST',
        transformRequest: (data, headersGetter) =>
          angular.toJson(TransformRTMPPushChannelClientToAPI(data)),
        transformResponse: (data, headersGetter, status) =>
          TransformRTMPPushChannelAPIToClient(angular.fromJson(data)),
      },
      delete: {
        method: 'DELETE',
      },
      update: {
        method: 'PUT',
        transformRequest: (data, headersGetter) =>
          angular.toJson(TransformRTMPPushChannelClientToAPI(data)),
        transformResponse: (data, headersGetter, status) =>
          TransformRTMPPushChannelAPIToClient(angular.fromJson(data)),
      },
    }
  );
});

export default module;



// WEBPACK FOOTER //
// ./app/resources/rtmp_push_channel.js